export default __webpack_public_path__ + "static/16-c3c21a55c8d60f32d8deff0f59b2aa49.webp";